import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-lg font-bold text-background-50 mb-4">
              <a href="/" className="cursor-pointer">东升大舞台</a>
            </h4>
            <p className="text-sm text-background-300 leading-relaxed">
              东升大舞台是专注演艺娱乐内容的优质平台，为您提供精彩纷呈的歌舞、戏曲、相声等演艺节目。官方正版应用，安全稳定，畅享无限精彩。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">教程分类</h4>
            <ul className="flex flex-col gap-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/" className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer">关于我们</Link>
              </li>
              <li>
                <a href="#download" className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer">App下载</a>
              </li>
              <li>
                <Link to="/category/faq" className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer">常见问题</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">联系方式</h4>
            <ul className="flex flex-col gap-2">
              <li className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-mail-line text-accent-500"></i>
                kefu@dongshengdawutai.com
              </li>
              <li className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-phone-line text-accent-500"></i>
                400-000-0000
              </li>
              <li className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-time-line text-accent-500"></i>
                工作日 9:00 - 18:00
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 东升大舞台 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer" rel="nofollow">用户协议</a>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}